<template>
  <mdb-container fluid class="faqwrapper">
    <mdb-container clcass="scondfaqwrapper">
      <div class="card card-image" style="background-image: url(/static/images/body/faqbg.jpg);">
        <div class="rgba-black-strong py-5 px-4">
          <row center class="accordion-gradient-bcg">
            <column md="10" xl="8">
              <mdb-accordion :panes="panes" gradient class="rgba-black-strong" ></mdb-accordion>
            </column>
          </row>
        </div>
      </div>
    </mdb-container>
  </mdb-container>
</template>

<script>
export default {
  data() {
    return {
      panes: [
        {
          title: '진짜 노마진? 최저금리  인가요?',
          icon: 'comment-dots',
          content: '일반적으로 견적서는 고객의 개인신용에 기반한 금융사 견적에 리스업체의 마진이 더해지는 구조입니다. <br><br> 위카는 기본적인 금융사 견적에 영업사원 마진을 최소화 하고 불필요한 마케팅 비용등을 절감하여 업계 최저금리를 실현하고 있습니다.',
        }, {
          title: '계약은 어떻게 이루어 지나요?',
          icon: 'comment-dots',
          content: '개인 소득자료 및 기본인적사항 등의서류를 전달 해주시면, 금융사(캐피탈)에서 심사를 진행합니다. <br><br> 이후 심사승인이 되면 금융사에서 보내온견적그대로 계약을 진행합니다.',
        },
        {
          title: ' 홈페이지에 나와있지않은차량도가능한가요?',
          icon: 'comment-dots',
          content: '위카는 국산차 뿐만아니라 고객님께서 문의주시는 차량도 확인 후 견적제공 해드리고있습니다. <br><br> 자세한 내용은 고객상담전화를 이용해 주시기 바랍니다.',
        },
        {
          title: '평소 알고지내는 딜러와 진행하되 위카의 리스를 이용 할 수 있나요?',
          icon: 'comment-dots',
          content: '네, 고객님이 원하시는 딜러와도 진행가능합니다. <br><br> 만약 그렇지 않다면, 위카에서 직접 자동차딜러와 컨텍하여 최대 할인을 제공 해 드릴수 있습니다.',
        },
      ],
    };
  },
};
</script>

<style scoped>
.faqwrapper {
  background-color: #212121;
  height: 1000px;
  width: 100%;
}

@media (max-width: 500px){
  .faqwrapper {
  height: 700px;
  padding: 0 0px
  }
}

.scondfaqwrapper {
  background-color: #212121;
  height: 1000px;
  width: 100%;
}

@media (max-width: 500px) {
  .scondfaqwrapper {
    height: 700px;
    padding: 0 0px;
  }
}

@media (max-width: 500px) {
  .container {
    padding-left: 0px;
    padding-right: 0px;
  }
}

@media (max-width: 500px) {
  .scondfaqwrapper {
    height: 700px;
    padding: 0 0px;
  }
}

.card {
  height: 1000px;
  width: 100%;
  padding-top:30%;
}

@media (max-width: 500px) {
  .card {
    padding-top:60%;
    height: 700px;
    padding-right: 0px;
    padding-left: 0px;
  }
}

.card-header .p-0  {
  background-color: black !important;
  transition: .3s;
}
.card-header {
  background-color: black !important;
  transition: .3s;
}
.card {
  font-weight: 800 !important;
  border: 0;
  -webkit-box-shadow: 0 2px 5px 0 rgba(0,0,0,0.16), 0 2px 10px 0 rgba(0,0,0,0.12);
  box-shadow: 0 2px 5px 0 rgba(0,0,0,0.16), 0 2px 10px 0 rgba(0,0,0,0.12);
}
.navbar {
  font-weight: 600;
}
</style>
